import AOS from "aos";

export default class AnimateOnScroll {
	constructor() {
		this.init();
		this.observeBody();
	}

	init() {
		AOS.init({
			duration: 300,
			easing: "ease-in-out",
		});
	}

	refresh() {
		AOS.refresh();
	}

	observeBody() {
		const observer = new ResizeObserver(() => this.refresh());
		observer.observe(document.body);
	}
}
